import { httpsCallable } from 'firebase/functions'
import { functions } from '../firebase'

export async function handleErrorDetail(errorDetail, userData, allMessages) {
  if (!errorDetail || !userData) return { reason: '' }

  const { detail = null } = errorDetail
  const { innererror = null, message = '', code = '' } = detail || {}
  if (code === 'content_filter') {
    await handleFilteringError(innererror, userData, allMessages)
    return { reason: 'content_filter' }
  }
  return { reason: '' }
}

export async function handleFilteringError(innererror, userData, allMessages) {
  if (!userData) return
  const { role = '' } = userData
  if (role !== 'student') return

  try {
    const call = httpsCallable(functions, 'send_message_to_tutor')
    const { schoolDocId, studentDocId } = userData
    let content
    if (!allMessages || !Array.isArray(allMessages) || !allMessages.length) {
      content = ''
    } else {
      content = allMessages[allMessages.length - 1].content ?? ''
    }
    const data = { schoolDocId, studentDocId, content }
    const res = await call(data)
    if (!res.data.success) throw new Error('Unexpected error occurred')
  } catch (e) {
    console.error('Failed to send message to tutor', e.message)
    console.error(e)
  }
}
